import React from "react";
import Table from "sc/ui/components/Table";
import PageTitle from "../../components/PageTitle";
import { connect } from "react-redux";
import { partnersPageLoad } from "../../actions/partners";
import { impersonate } from "../../actions/auth";
import { uiQueues, uiPartnersLoadInProgress } from "../../selectors/partners";
import { Panel } from "react-bootstrap";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";

export default connect(
  (state, ownProps) => ({
    queues: uiQueues(state),
    loading: uiPartnersLoadInProgress(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(partnersPageLoad()),
    onImpersonatePartner: partnerId => dispatch(impersonate(partnerId)),
  }),
)(
  componentWithLoadTrigger(props => {
    const actions = [
      {
        id: "impersonate-partner",
        text: " Engineers & Schedule",
        className: "btn-primary",
        glyph: "glyphicon glyphicon-eye-open",
        onClick: props.onImpersonatePartner,
      },
    ];

    const columns = [
      {
        header: "",
        data: queue => queue.name,
      },
    ];

    return (
      <div id="queues-page">
        <PageTitle title="Queues" />
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Queues list</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Table
              data={props.queues}
              columns={columns}
              actions={actions}
              identityProperty="partnerId"
              noDataMessage="No partners in the system"
              loading={props.loading}
              loadingMessage="Loading..."
            />
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/tech/Queues.js